import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { NavigationService } from '../services/navigation/navigation.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private navigationService: NavigationService,
    private router: Router
  ) {}

  async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const user = this.authenticationService.user;
    if (!user) {
      return this.redirectToLogin(state);
    }

    const navigationItem = this.navigationService.getItemByUrl(state.url);

    if (!navigationItem) {
      return true;
    }

    const hasPermission = navigationItem.permissionName ? this.authenticationService.hasPermission(navigationItem.permissionName) : true;
    const hasFeatureFlagProperty = Boolean(navigationItem.featureFlag);
    const hasFeatureFlag = hasFeatureFlagProperty && this.authenticationService.hasFlags(navigationItem.featureFlag);

    if (hasPermission && (!hasFeatureFlagProperty || hasFeatureFlag)) {
      return true;
    }

    const firstVisibleItem = this.navigationService.getFirstVisibleItem();
    if (firstVisibleItem) {
      location.href = firstVisibleItem.url;
      return false;
    }

    await this.authenticationService.logout();
    return this.redirectToLogin(state);
  }

  async redirectToLogin(state: RouterStateSnapshot): Promise<boolean> {
    if (location.href.endsWith('/404')) { return; }

    localStorage.setItem('REDIRECT_TO_URL_AFTER_LOGIN', location.href);
    await this.router.navigateByUrl('/login');

    return false;
  }
}
